import { pipeline } from "@huggingface/transformers";

export async function check_audio(
  model: Blob,
  audio: Blob,
  baseWord: string
): Promise<boolean> {
  const modelUrl = URL.createObjectURL(model);
  const transcriber = await pipeline("automatic-speech-recognition", modelUrl, {
    device: "webgpu",
  });

  const audioUrl = URL.createObjectURL(audio);

  const result = await transcriber(audioUrl);
  const transcription: string = result.text.toLowerCase().trim();

  const similiar = transcription.includes(baseWord);

  return similiar;
}

export async function check_image(
  model: Blob,
  image: Blob,
  baseWord: string
): Promise<boolean> {
  const modelUrl = URL.createObjectURL(model);
  const imageUrl = URL.createObjectURL(image);
  const classifier = await pipeline("image-classification", modelUrl, {
    device: "webgpu",
  });
  const result = await classifier(imageUrl);
}
